(ns hai.contacts.header
  "The tinted header row every contacts surface shares: people icon + title (a
   link when `:href` is given) with action buttons on the right — or, with
   `:on-back`, \"← Back to contacts\" in the title's place. Actions come as
   children — hosts wrap their own `:button.bar-action-btn`s in tooltips as
   needed. Mirrors [[hai.tasks.header]]."
  (:require
   [hai.entity.sections :as sections]
   [hai.mini-apps.add-pill :as add-pill]
   [hai.ui.icons :as icons]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(def ^:private back-icon (icons/mui-icon :outlined :arrow_back))

;; One height for every card header, with or without the ＋ pill: the minimum
;; governs and the row centres whatever it holds, so no vertical padding.
(o/defstyled bar :div
  {:display "flex" :align-items "center" :gap "10px"
   :padding "0 18px"
   :min-height "56px"
   :box-sizing "border-box"
   :background t/--contact
   :color t/--note-kraft}
  [:.bar-icon
   {:display "inline-flex" :align-items "center"
    :color t/--note-kraft}
   ;; Material fill icon (unlike the stroke icons elsewhere) — keep the page's
   ;; `svg {fill: currentColor}` and pin its size.
   [:svg {:fill "currentColor" :width "20px" :height "20px"}]]
  [:.bar-title
   {:font-size "16px" :font-weight "700" :line-height "1.2"
    :margin "0"
    :letter-spacing "-0.005em"
    :color t/--note-kraft}]
  [:.bar-title-link
   {:display "inline-flex" :align-items "center" :gap "10px"
    :color "inherit"
    :text-decoration "none"
    :cursor "pointer"}
   [:&:hover
    [:.bar-title {:text-decoration "underline" :text-underline-offset "3px"}]]]
  [:.bar-back
   {:display "inline-flex" :align-items "center" :gap "10px"
    :padding "0"
    :border "none" :background "transparent"
    :font-family "inherit"
    :color "inherit"
    :cursor "pointer"}
   [:&:hover
    [:.bar-title {:text-decoration "underline" :text-underline-offset "3px"}]]]
  [:.bar-actions
   {:margin-left "auto"
    :display "flex" :align-items "center" :gap "6px"}]
  ;; The ＋ Contact pill, outlined in the deeper sky blue the contacts page
  ;; fills its own Add contact button with — as the tasks pill is in its sage.
  [add-pill/pill {:border "1px solid" :border-color t/--contact-add-fill}]
  [:.bar-action-btn
   {:width "28px" :height "28px"
    :border "none" :border-radius "999px"
    :background "transparent"
    :padding "0"
    :color t/--note-kraft
    :cursor "pointer"
    :display "inline-flex" :align-items "center" :justify-content "center"
    :transition "background 0.15s ease"}
   [:&:hover {:background t/--note-kraft-10}]
   [:svg {:fill "currentColor"}]]
  ;; A ⋮ among the actions is a round header button too, not the rounded
  ;; square it is on a contact.
  [sections/kebab-wrap
   [:button
    {:width "28px" :height "28px" :border-radius "999px"
     :color t/--note-kraft}
    [:&:hover {:background t/--note-kraft-10 :color t/--note-kraft}]]]
  ([{:keys [title href target rel on-back]} & actions]
   ;; Keep the root fragment's first child a concrete element (never a bare
   ;; `[:<>]`): Ornament's fragment-flattening recurses into a leading `:<>`
   ;; child and drops its siblings, which would silently swallow the whole
   ;; `.bar-actions` group.
   (into
    [:<>]
    (concat
     (cond
       on-back
       [[:button.bar-back {:type "button" :on-click on-back}
         [:span.bar-icon [back-icon]]
         [:span.bar-title "Back to contacts"]]]

       href
       [[:a.bar-title-link {:href href :target target :rel rel}
         [:span.bar-icon [icons/humble-contact]]
         [:h2.bar-title title]]]

       :else
       [[:span.bar-icon [icons/humble-contact]]
        [:h2.bar-title title]])
     [(into [:div.bar-actions] actions)]))))
